import { DateTime } from 'luxon';
import { ErrorType } from './errorType.enum';

export interface Error {
  id: string;
  errorType: ErrorType;
  creationDate: string;
  userEmail: string;
  isSolved: boolean;
  // font display only
  template?: ErrorTemplate;
}

export interface ErrorTemplate {
  errorType: ErrorType;
  errorSeverity: ErrorSeverity;
  title: string;
  description: string;
  action: string;
}

export interface ErrorTemplateCount extends ErrorTemplate {
  recentOccurences: number;
  lastOccurence: string;
  // font display only
  open?: boolean;
}

export enum ErrorSeverity {
  CRITICAL,
  WARNING,
  INFO,
  SUCCESS
}

export interface ErrorConfiguration {
  startDate: DateTime;
  endDate: DateTime;
  severities: Array<ErrorSeverity>;
}

export enum ErrorDisplay {
  DEFAULT,
  COLLAPSED,
  EXTENDED
}
